import React, { useContext } from 'react';
import _ from 'lodash';
import MultiButtonSwitch from './editors/MultiButtonSwitch';
import ModelIdSelector from '../lego/ModelIdSelector';
import MultiCountryEditor from './editors/MultiCountryEditor';
import StableUrlsWidget from '../lego/stable-urls/StableUrlsWidget';
import { LocalesSelector } from '../lego/LocalesSelector';
import { IconButton } from './IconButton';
import LegoAdminPageContext from '../../pages/legoAdminPageContext';

const STABLE_URL_TYPES = [
  { value: 'fusebox', label: 'Fusebox' },
  { value: 'manual', label: 'Manual' }
];

export function StableUrlsFiltersBar({ filter, onChange }) {
  const { page } = useContext(LegoAdminPageContext);
  const stableUrlsService = page.service('/services/stable-urls/changes');
  const f = filter || {};
  const { type = 'fusebox', key, country, locale } = f;

  const onFieldChange = (field, value) => {
    let newFilter = _.cloneDeep(f);
    if (value === undefined || value === '' || value === null) {
      delete newFilter[field];
    } else {
      newFilter[field] = value;
    }
    onChange(newFilter);
  };

  const refreshModel = () => {
    if (!key) return;
    stableUrlsService.patch('', { type: 'fusebox', keys: [key] });
  };

  return <div className={'d-flex align-items-center'} style={{ gap: '10px' }}>
    <MultiButtonSwitch value={type} options={STABLE_URL_TYPES} onChange={(v) => onFieldChange('type', v)} />

    <LocalesSelector value={locale} onChange={(v) => onFieldChange('locale', v)} />

    <span style={{ width: '160px', display: 'inline-block' }}>
      <MultiCountryEditor className={'zoom-90'} value={country || null} onChange={(v) => onFieldChange('country', v)} />
    </span>

    <span>Key:</span>

    <ModelIdSelector value={key || null} onChange={(v) => onFieldChange('key', v)} />

    {key && type === 'fusebox' ? (
      <IconButton icon="sync" level="primary" small onClick={refreshModel}>Resync model</IconButton>
    ) : null}

    <StableUrlsWidget />
  </div>;
}
